"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = exports.Nav = void 0;

var tslib_1 = require("tslib");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var getAlignment = function getAlignment(align) {
  switch (align) {
    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    default:
      return 'flex-start';
  }
};

exports.Nav = styled_components_1.default.nav(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-grow: 1;\n  align-items: flex-end;\n  justify-content: ", ";\n\n  > div {\n    display: flex;\n    height: 100%;\n  }\n\n  @media (max-width: 35rem) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-grow: 1;\n  align-items: flex-end;\n  justify-content: ", ";\n\n  > div {\n    display: flex;\n    height: 100%;\n  }\n\n  @media (max-width: 35rem) {\n    display: none;\n  }\n"])), function (_a) {
  var align = _a.align;
  return getAlignment(align);
});
exports.Heading = (0, styled_components_1.default)(ui_text_1.Text)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  margin: 0.75rem 0;\n  width: 100%;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  margin: 0.75rem 0;\n  width: 100%;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: ", ";\n"])), function (_a) {
  var align = _a.align;
  return getAlignment(align);
});
var templateObject_1, templateObject_2;